import script from "./Carousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./Carousel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__